<nb-layout class="welcome-view">
  <nb-layout-header fixed>
    <nb-actions size="small" class="header-left">
      <nb-action class="ml-auto">
        <a href="/" class="mr-auto">
          <img
            src="assets/images/ethinking-logo.svg"
            height="50"
            alt="Push-Logo"
          />
          <span>ethinking.push {{ stage }}</span>
        </a>
      </nb-action>
    </nb-actions>
  </nb-layout-header>

  <nb-layout-column>
    <router-outlet></router-outlet>
  </nb-layout-column>

  <nb-layout-footer>
    <nb-actions size="small">
      <nb-action>
        <a href="https://ethinking.de/privacy" target="_blank">{{
          "privacy_title" | translate
        }}</a>
      </nb-action>
      <nb-action>
        <a href="https://ethinking.de/imprint" target="_blank">{{
          "imprint_title" | translate
        }}</a>
      </nb-action>
    </nb-actions>
  </nb-layout-footer>
</nb-layout>
